var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000108987206576630743500000006811629234087199919_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28.1 28",
    style: {
      enableBackground: "new 0 0 28.1 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.1,16.6v0.4c0,2.6,0,5.3,0,7.9c0,1.9-1.3,3.2-3.2,3.2c-1.4,0-2.8,0-4.2,0c-0.7,0-1-0.3-1-1 c0-2.1,0-4.2,0-6.3c0-1-0.5-1.5-1.6-1.5c-0.8,0-1.6,0-2.4,0c-0.9,0-1.5,0.6-1.5,1.5c0,2.1,0,4.2,0,6.3c0,0.7-0.3,1-1,1 c-1.4,0-2.8,0-4.2,0C4.3,28,3,26.7,3,24.9c0-2.6,0-5.3,0-7.9v-0.4c-0.1,0-0.2,0-0.3,0c-1.1,0-2.1-0.6-2.5-1.6 c-0.4-1.1-0.2-2,0.6-2.8C2.5,10.4,4.3,8.6,6,6.9c2-2,4.1-4,6.1-6.1c1-1.1,2.9-1.1,3.9,0c3.7,3.8,7.5,7.5,11.3,11.3 c1.2,1.2,1,3.3-0.5,4.1c-0.4,0.2-0.8,0.4-1.2,0.4C25.4,16.6,25.3,16.6,25.1,16.6L25.1,16.6z M18.4,26.4c1.2,0,2.3,0,3.5,0 c1,0,1.6-0.5,1.6-1.6c0-3,0-6,0-8.9c0-0.6,0.3-0.9,1-0.9c0.4,0,0.8,0,1.1,0c0.4,0,0.8-0.3,0.9-0.7c0.1-0.5-0.1-0.8-0.4-1.1 C22.3,9.4,18.6,5.7,14.9,2c-0.6-0.6-1.1-0.6-1.6,0c-3.3,3.3-6.6,6.6-9.9,9.9c-0.5,0.4-0.9,0.9-1.4,1.4c-0.3,0.3-0.4,0.7-0.2,1.1 c0.2,0.4,0.5,0.6,0.9,0.6c0.3,0,0.6,0,0.9,0c0.8,0,1.1,0.3,1.1,1.1c0,2.9,0,5.9,0,8.8c0,1,0.7,1.6,1.6,1.6c1.1,0,2.1,0,3.2,0h0.3 c0-0.1,0-0.3,0-0.4c0-1.9,0-3.7,0-5.6c0-1.5,1.2-2.7,2.6-2.8c1.1-0.1,2.2,0,3.4,0c0.1,0,0.2,0,0.3,0c1.4,0.3,2.4,1.5,2.4,3 c0,1.8,0,3.6,0,5.4C18.4,26.1,18.4,26.2,18.4,26.4L18.4,26.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon11);
export default __webpack_public_path__ + "static/media/icon11.c5c478c60ef8fb8d19a0fe1a4ee0e816.svg";
export { ForwardRef as ReactComponent };